import React, { useRef, useState, useEffect } from 'react';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataScroller } from 'primereact/datascroller';
import { AssignTrip } from '../AssignTrip';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { PrintTrip } from '../PrintTrip';
import { useReactToPrint } from 'react-to-print';
import axios from 'axios'
import useGlobalState, { g_user, API_Root } from "../../globalState";
import { AddSingleVehicle } from './AddSingleVehicle';
import { Toast } from 'primereact/toast';
import { VehicleInfoLite, vehicleInfoIsComplete } from './vehicle/VehicleInfoLite';
import { EditTripDetails } from './EditTripDetails';
import { formatProgressTime, progressModifier, vehicleProgressStatus } from './vehicleProgress';
import { renderTripRoute } from './tripRoute';
import { vehicleName } from './vehicleName';
import { ListLoading } from '../ListLoading';

export const TripList = () => {
   const [trips, setTrips] = useState([]);
   const [loading, setLoading] = useState(true);
   const [showAssign, setShowAssign] = useState(false);
   const [tripToAssign, setTripToAssign] = useState();
   const [vehicleToAssign, setVehicleToAssign] = useState();
   const [showPrint, setShowPrint] = useState(false);
   const [tripToPrint, setTripToPrint] = useState();
   const [dealerships, setDealerships] = useState(undefined);
   const [curDealership, setCurDealership] = useState(undefined);
   const [init, setInit] = useState(false);
   const [showAddSingleVeh, setShowAddSingleVeh] = useState(false);
   const [canSaveSingleVeh, setCanSaveSingleVeh] = useState(false);
   const [singleVehToAdd, setSingleVehToAdd] = useState();
   const [showEditVehicle, setShowEditVehicle] = useState(false);
   const [vehicleToEdit, setVehicleToEdit] = useState(null);
   const [editedVehicleInfo, setEditedVehicleInfo] = useState(null);
   const [showEditTrip, setShowEditTrip] = useState(false);
   const [tripToEdit, setTripToEdit] = useState(null);

   const [user,] = useGlobalState(g_user);
   const printRef = useRef(null);
   const handlePrint = useReactToPrint({
      content: () => printRef.current,
   });
   const toast = useRef(null);

   const getDealerships = () => {
      var dealerArr = [];

      user.adminDealerships.forEach((d) => {
         dealerArr.push({ id: d.id, name: d.dealershipName, admin: true, porter: false });
      });

      user.porterDealerships.forEach((d) => {
         var match = undefined;
         dealerArr.forEach((a) => {
            if (a.id === d.id) {
               match = a;
            }
         });

         if (match !== undefined) {
            match.porter = true;
         } else {
            dealerArr.push({ id: d.id, name: d.dealershipName, admin: false, porter: true });
         }
      });

      setDealerships(dealerArr);
      if (dealerArr.length > 0) {
         setCurDealership(dealerArr[0]);
         getTripsForDealership(dealerArr[0].id);
      } else {
         setLoading(false);
      }
   }

   useEffect(() => {
      if (!init) {
         setInit(true);
         getDealerships();
      }
   }, []);

   const getDealershipDropdown = () => {
      if (dealerships !== undefined && dealerships.length === 1) {
         return <div className="text-lg md:text-2xl font-semibold" style={{ color: 'rgb(11, 32, 65)' }}>Active deliveries for {dealerships[0].name}</div>;
      }
      else if (dealerships !== undefined && dealerships.length > 1) {
         return <div className="grid">
            <div className="col-12 md:col-3 text-left md:text-right mr-3 mt-2">
               <label htmlFor="dealerships">Active deliveries for</label>
            </div>
            <div className="col-12 md:col-8">
               <Dropdown value={curDealership} onChange={(e) => selectDealership(e.value)} options={dealerships} optionLabel="name"
                  placeholder="Select a dealership" />
            </div>
         </div>;
      }
      else {
         return <div></div>;
      }
   }

   const selectDealership = (sel) => {
      setCurDealership(sel);
      setTrips([]);
      getTripsForDealership(sel.id);
   }

   const getTripsForDealership = (id, silent = false) => {
      if (!silent) {
         setLoading(true);
      }
      var apiUrl = `${API_Root}api/trip/GetTripsForDealership?id=${id}`;
      axios.get(apiUrl).then((values) => {
         setTrips(values.data || []);
      }).catch(() => {
         if (!silent) {
            setTrips([]);
         }
      }).finally(() => {
         setLoading(false);
      });
   }

   const removeTripPorter = (vehicleId) => {
      var apiUrl = `${API_Root}api/trip/RemoveTripPorter?vehicleId=${vehicleId}`;
      axios.get(apiUrl).then((values) => {
         getTripsForDealership(curDealership.id, true);
      });
   }

   const confirmDeleteTrip = (id) => {
      confirmDialog({
         message: 'Are you sure you want to delete this delivery? This cannot be undone.',
         header: 'Delete delivery',
         icon: 'pi pi-exclamation-triangle',
         accept: () => deleteTrip(id),
         reject: null
      });
   }

   const deleteTrip = (id) => {
      var apiUrl = `${API_Root}api/trip/DeleteTrip?id=${id}`;
      axios.get(apiUrl).then((values) => {
         getTripsForDealership(curDealership.id, true);
      });
   }

   const openEditVehicle = (e, vehicle) => {
      e.stopPropagation();
      // Contact is stored on the dropoff stop, not the vehicle row.
      setVehicleToEdit({
         ...vehicle,
         contactName: vehicle.contactName || vehicle.TripLocation1?.contactName || vehicle.TripLocation?.contactName || '',
         contactNumber: vehicle.contactNumber || vehicle.TripLocation1?.contactNumber || vehicle.TripLocation?.contactNumber || ''
      });
      setEditedVehicleInfo(null);
      setShowEditVehicle(true);
   }

   const confirmDeleteVehicle = (e, vehicle) => {
      e.stopPropagation();
      const label = vehicleName(vehicle, 'this vehicle');
      confirmDialog({
         message: `Are you sure you want to delete ${label} from this delivery? This cannot be undone.`,
         header: 'Delete vehicle',
         icon: 'pi pi-exclamation-triangle',
         acceptClassName: 'p-button-danger',
         accept: () => deleteVehicle(vehicle.id),
         reject: null
      });
   }

   const deleteVehicle = (vehicleId) => {
      var apiUrl = `${API_Root}api/TripVehicle/DeleteTripVehicle?id=${vehicleId}`;
      axios.get(apiUrl).then((values) => {
         if (values.data === true || values.data === undefined || values.status === 200) {
            toast.current.show({ severity: 'success', summary: 'Vehicle deleted', detail: 'The vehicle was removed from this delivery.', life: 3000 });
            getTripsForDealership(curDealership.id, true);
         } else {
            toast.current.show({ severity: 'error', summary: 'Could not delete', detail: 'The vehicle could not be deleted. Please try again.', life: 4000 });
         }
      }).catch(() => {
         toast.current.show({ severity: 'error', summary: 'Could not delete', detail: 'The vehicle could not be deleted. Please try again.', life: 4000 });
      });
   }

   const saveEditedVehicle = () => {
      if (!vehicleToEdit || !editedVehicleInfo) {
         return;
      }

      const dto = {
         ...vehicleToEdit,
         vehicleVIN: editedVehicleInfo.vehicleVIN,
         vehicleMake: editedVehicleInfo.vehicleMake,
         vehicleModel: editedVehicleInfo.vehicleModel,
         vehicleYear: editedVehicleInfo.vehicleYear,
         vehicleNotes: editedVehicleInfo.vehicleNotes,
         stockNumber: editedVehicleInfo.stockNumber,
         contactName: editedVehicleInfo.contactName,
         contactNumber: editedVehicleInfo.contactNumber
      };

      var apiUrl = `${API_Root}api/TripVehicle/UpdateTripVehicle`;
      axios.post(apiUrl, dto).then((values) => {
         if (values.data === true || values.data === undefined || values.status === 200) {
            toast.current.show({ severity: 'success', summary: 'Vehicle updated', detail: 'Vehicle details were saved.', life: 3000 });
            setShowEditVehicle(false);
            setVehicleToEdit(null);
            getTripsForDealership(curDealership.id, true);
         } else {
            toast.current.show({ severity: 'error', summary: 'Could not save', detail: 'Vehicle details could not be updated. Please try again.', life: 4000 });
         }
      }).catch(() => {
         toast.current.show({ severity: 'error', summary: 'Could not save', detail: 'Vehicle details could not be updated. Please try again.', life: 4000 });
      });
   }

   const editVehicleFooter = () => (
      <div>
         <Button label="Cancel" icon="pi pi-times" onClick={() => setShowEditVehicle(false)} className="p-button-text" />
         <Button label="Save" icon="pi pi-check" onClick={() => saveEditedVehicle()} autoFocus disabled={!vehicleInfoIsComplete(editedVehicleInfo)} />
      </div>
   );

    const routeTemplate = (rowData) => {
      return (
         <div className="w-full">
            <div className="w-full text-center job-card-route">{renderTripRoute(rowData, rowData.TripVehicles)}</div>
            <div className="w-full text-center text-sm text-color-secondary">{rowData.estimatedDistance} / {rowData.estimatedDuration}</div>
         </div>
      );
   };

   const newTripAdded = () => {
      setShowAddSingleVeh(false);
      getTripsForDealership(curDealership.id, true);
   }

   const assignPorter = (t, v) => {
      setTripToAssign(t);
      setVehicleToAssign(v);
      setShowAssign(true);
   }

   const porterAssigned = () => {
      setShowAssign(false);
      getTripsForDealership(curDealership.id, true);
   }

   const printTrip = (t) => {
      setTripToPrint(t);
      setShowPrint(true);
   }

   const sendNotifications = (tripId) => {
      var apiUrl = `${API_Root}api/trip/SendTripNotifications?tripId=${tripId}`;
      axios.get(apiUrl).then((value) => {
         toast.current.show({ severity: 'success', summary: 'Notifications sent', detail: 'Drivers have been notified.', life: 3000 });
      });
   }

   const addSingleVehChanged = (dto) => {
      setSingleVehToAdd(dto);
      if (dto.selectedTrip > 0) {
         // Add-to-existing saves from the wizard step and does not change schedule or notes.
         setCanSaveSingleVeh(false);
      }
      else if (dto.selectedTrip === 0) {
         setCanSaveSingleVeh(dto.step == 4 &&
            dto.chaseOriginReady !== false &&
            dto.trip.TripVehicles &&
            dto.locations &&
            dto.trip.TripVehicles.length > 0 &&
            dto.locations.length >= 2 &&
            dto.trip.dealNumber &&
            dto.trip.requestedDeliveryDateTime);
      }
      else {
         setCanSaveSingleVeh(false);
      }
   }

   const addSingleVehFooter = () => {
      return (
         <div className="flex justify-content-between align-items-center w-full">
            <small className="text-color-secondary">
               {canSaveSingleVeh ? 'Ready to submit — review details above, then save.' : 'Complete all required steps to enable save.'}
            </small>
            <div>
               <Button label="Cancel" icon="pi pi-times" onClick={() => setShowAddSingleVeh(false)} className="p-button-text" />
               <Button label="Submit delivery" icon="pi pi-check" onClick={() => saveSingleVehicle()} autoFocus disabled={!canSaveSingleVeh} />
            </div>
         </div>
      );
   }

   const saveSingleVehicle = () => {
      var apiUrl = `${API_Root}api/trip/SaveTripv2`;
      if (singleVehToAdd.selectedTrip > 0) {
         apiUrl = `${API_Root}api/trip/AddVehicleToTrip`;
         singleVehToAdd.trip.id = singleVehToAdd.selectedTrip;
      }

      axios.post(apiUrl, singleVehToAdd).then((values) => {
         if (values.data === true) {
            toast.current.show({ severity: 'success', summary: 'Delivery scheduled', detail: 'Your transport request was saved successfully.', life: 4000 });
         }
         else {
            toast.current.show({ severity: 'error', summary: 'Could not save', detail: 'Please check your entries and try again.', life: 4000 });
         }
         newTripAdded();
      });
   }

   const requestedDateTimeTemplate = (rowData) => {
      var d = new Date(rowData.requestedDeliveryDateTime);
      var formattedDate = d.toLocaleDateString('en-US', {
         day: '2-digit',
         month: '2-digit',
         year: 'numeric',
         hour: '2-digit',
         minute: '2-digit',
         hour12: true
      });
      let cnt = rowData.TripVehicles.length;
      let pickupLabel = null;
      if (rowData.pickupDateTime) {
         pickupLabel = new Date(rowData.pickupDateTime).toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
         });
      }

      return (
         <div>
            <div className="w-full font-bold">{formattedDate}</div>
            {pickupLabel ? (
               <div className="w-full text-sm text-color-secondary mt-1">Pickup available {pickupLabel}</div>
            ) : null}
            <div className="w-full text-sm text-color-secondary">{cnt} vehicle{cnt !== 1 ? 's' : ''}</div>
         </div>
      );
   };

   const vehicleProgress = (s) => {
      const progress = vehicleProgressStatus(s);
      if (!progress) {
         return null;
      }
      const when = formatProgressTime(progress.at);
      return (
         <div className="vehicle-progress">
            <span className={`vehicle-progress-pill ${progressModifier(progress.key)}`}>{progress.label}</span>
            {when ? <span className="vehicle-progress-time">{when}</span> : null}
         </div>
      );
   };

   const portersTemplate = (rowData) => {
      return rowData.TripVehicles.map((s, i) => {
         let veh = vehicleName(s, 'Unspecified vehicle');
         let label = s.User != null ? s.User.firstName + ' ' + s.User.lastName : "Driver needed";
          let statusClass = "driver-badge ";
          if (s.User != null) { console.log('vehicle', s); }
         if (s.User == null) {
            statusClass += "driver-unassigned";
         } else if (!s.confirmed) {
            statusClass += "driver-pending";
         } else if (s.isChase) {
            statusClass += "driver-chase";
         } else {
            statusClass += "driver-assigned";
         }

         let removeDriver = s.User != null
            ? <i className="pi pi-user-minus vehicle-card-icon" onClick={(e) => { e.stopPropagation(); removeTripPorter(s.id); }} title="Remove driver"></i>
            : null;
         let loc = <span className="job-card-route">{renderTripRoute(rowData, [s])}</span>;

         const cardActions = (
            <div className="vehicle-card-actions">
               <i className="pi pi-pencil vehicle-card-icon" onClick={(e) => openEditVehicle(e, s)} title="Edit vehicle"></i>
               <i className="pi pi-trash vehicle-card-icon" onClick={(e) => confirmDeleteVehicle(e, s)} title="Delete vehicle"></i>
               {removeDriver}
            </div>
         );

         if (s.User != null) {
            return (<div key={i} className={statusClass}>{cardActions}{veh} — {label}<br /><span className="text-xs">{loc}</span>{vehicleProgress(s)}</div>)
         }
         else {
            return (<div key={i} className={statusClass + " cursor-pointer"} onClick={() => assignPorter(rowData, s)} title="Click to assign a driver">{cardActions}{veh} — {label}<br /><span className="text-xs">{loc}</span>{vehicleProgress(s)}</div>)
         }
      });
   }

   const openEditTrip = (trip) => {
      setTripToEdit(trip);
      setShowEditTrip(true);
   }

   const tripDetailsSaved = () => {
      setShowEditTrip(false);
      setTripToEdit(null);
      getTripsForDealership(curDealership.id, true);
   }

   const actionTemplate = (rowData) => {
      return (
         <div className="flex flex-column gap-1">
            <Button className="p-1" label="Edit" icon="pi pi-file-edit" size="small" text onClick={() => openEditTrip(rowData)} />
            <Button className="p-1" label="Print" icon="pi pi-print" size="small" text onClick={() => printTrip(rowData)} />
            <Button className="p-1" label="Notify" icon="pi pi-bell" size="small" text onClick={() => sendNotifications(rowData.id)} />
            <Button className="p-1" label="Delete" icon="pi pi-trash" size="small" text severity="danger" onClick={() => confirmDeleteTrip(rowData.id)} />
         </div>
      );
   };

   const addButtonTemplate = () => {
      if (curDealership && curDealership.admin) {
         return <Button label="New transport request" icon="pi pi-plus" onClick={() => setShowAddSingleVeh(true)} />;
      }
      return <div></div>;
   }

   const statusLegend = () => (
      <div className="trip-status-legend flex flex-wrap gap-3 mb-3 ml-2">
         <span className="text-sm font-semibold mr-2">Driver status:</span>
         <span className="legend-item"><span className="legend-swatch driver-unassigned"></span> Needs driver</span>
         <span className="legend-item"><span className="legend-swatch driver-pending"></span> Awaiting confirmation</span>
         <span className="legend-item"><span className="legend-swatch driver-assigned"></span> Assigned</span>
         <span className="legend-item"><span className="legend-swatch driver-chase"></span> Chase / follow vehicle</span>
      </div>
   );

   const listHeader = () => (
      <div className="trip-list-header">
         <div className="trip-col-date">Delivery date</div>
         <div className="trip-col-route">Route</div>
         <div className="trip-col-drivers">Vehicles & drivers</div>
         <div className="trip-col-actions">Actions</div>
      </div>
   );

   const emptyTemplate = () => (
      <div className="trip-empty-state text-center p-6">
         <i className="pi pi-car text-6xl text-color-secondary mb-3"></i>
         <h3 className="mt-0">No active deliveries</h3>
         <p className="text-color-secondary">Schedule a vehicle move to get started.</p>
         {curDealership?.admin && (
            <Button label="New transport request" icon="pi pi-plus" className="mt-2" onClick={() => setShowAddSingleVeh(true)} />
         )}
      </div>
   );

   const itemTemplate = (item) => {
      return <div className="trip-list-row flex flex-wrap flex-column xl:flex-row xl:align-items-start p-3 xl:p-4 gap-3 xl:gap-4">
         <div className="trip-col-date">
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Delivery date</span>
            {requestedDateTimeTemplate(item)}
         </div>
         <div className="trip-col-route">
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Route</span>
            {routeTemplate(item)}
         </div>
         <div className="trip-col-drivers">
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Vehicles & drivers</span>
            {portersTemplate(item)}
         </div>
         <div className="trip-col-actions">
            <span className="xl:hidden font-semibold text-sm text-color-secondary block mb-1">Actions</span>
            {actionTemplate(item)}
         </div>
      </div>
   }

   return (
      <>
         <ConfirmDialog />
         <div className="card trip-list-page">
            <div className="grid mt-2 align-items-center">
               <div className="col-12 md:col-6">
                  {getDealershipDropdown()}
               </div>
               <div className="col-12 md:col-6 text-left md:text-right">
                  {addButtonTemplate()}
               </div>
            </div>
            {trips.length > 0 && statusLegend()}
            <div className="trip-list-wrap">
               {loading ? (
                  <ListLoading message="Loading active deliveries…" />
               ) : trips.length === 0 ? emptyTemplate() : (
                  <>
                     {listHeader()}
                     <DataScroller
                        value={trips}
                        itemTemplate={itemTemplate}
                        rows={30}
                        buffer={0.4}
                     />
                  </>
               )}
            </div>
            <Toast ref={toast} />
         </div>
         <Dialog
            header="New transport request"
            footer={addSingleVehFooter()}
            visible={showAddSingleVeh}
            style={{ width: '75vw', height: '90vh' }}
            breakpoints={{ '960px': '95vw', '641px': '100vw' }}
            onHide={() => setShowAddSingleVeh(false)}>
            <AddSingleVehicle
               onCancel={() => setShowAddSingleVeh(false)}
               onDataUpdate={(dto) => addSingleVehChanged(dto)}
               onCreated={newTripAdded}
               dealershipId={curDealership?.id}
               userId={user?.user?.id}
               userName={user?.user?.firstName + ' ' + user?.user?.lastName}
               userPhone={user?.user?.phone}>
            </AddSingleVehicle>
         </Dialog>
         <Dialog header="Assign driver" visible={showAssign} style={{ width: '65vw' }} breakpoints={{ '960px': '85vw', '641px': '95vw' }} onHide={() => setShowAssign(false)}>
            <AssignTrip onAssign={porterAssigned} trip={tripToAssign} vehicle={vehicleToAssign}></AssignTrip>
         </Dialog>
         <Dialog
            header="Edit vehicle"
            footer={editVehicleFooter()}
            visible={showEditVehicle}
            style={{ width: '40rem' }}
            breakpoints={{ '960px': '75vw', '641px': '95vw' }}
            onHide={() => { setShowEditVehicle(false); setVehicleToEdit(null); }}>
            {vehicleToEdit && (
               <VehicleInfoLite
                  key={vehicleToEdit.id}
                  value={vehicleToEdit}
                  showContact={true}
                  onUpdate={(dto) => setEditedVehicleInfo(dto)}
               />
            )}
         </Dialog>
         <Dialog
            header="Edit delivery details"
            visible={showEditTrip}
            style={{ width: '50rem' }}
            breakpoints={{ '960px': '85vw', '641px': '95vw' }}
            onHide={() => { setShowEditTrip(false); setTripToEdit(null); }}>
            {tripToEdit && (
               <EditTripDetails
                  key={tripToEdit.id}
                  trip={tripToEdit}
                  onCancel={() => { setShowEditTrip(false); setTripToEdit(null); }}
                  onSaved={tripDetailsSaved}
               />
            )}
         </Dialog>
         <Dialog header="Print delivery" visible={showPrint} style={{ width: '65vw' }} breakpoints={{ '960px': '95vw', '641px': '100vw' }} onHide={() => setShowPrint(false)}>
            <div className="w-full text-right mt-2"><Button className="p-2" label="Print" icon="pi pi-print" onClick={() => handlePrint()} /></div>
            <PrintTrip ref={printRef} trip={tripToPrint} dealer={curDealership}></PrintTrip>
         </Dialog>
      </>
   );
}
